import {Component, Input, OnInit} from '@angular/core';
import { ServiceJobDTOModel } from 'src/app/models/service-job-DTO.model';
import {DocumentModel} from '../../models/document.model';

@Component({
  selector: 'manual-ref',
  templateUrl: './manual-ref.component.html',
  styleUrls: ['./manual-ref.component.scss'],
})
export class ManualRefComponent implements OnInit {

  @Input() serviceJob: ServiceJobDTOModel;

    constructor() {
    }

    ngOnInit() {
        
    }

}
